import React from 'react';

import ColoredButton from './coloredButton';

const ColoredButtonLink = ({ url, primaryColor, text, icon, fluid, openInNewTab, basic, onClick, customColor, customFontColor, className }) => {
    return (
        <React.Fragment>
            {
                url &&
                <a href={url} target={openInNewTab ? "_blank" : ''}>
                    <ColoredButton color={primaryColor} className={className} fluid={fluid === false ? fluid : true} onClick={onClick}
                        basic={basic}
                        // re-enable when custom props are actually used
                        // customColor={customColor}
                        // customFontColor={customFontColor}
                        >
                        {text}
                    </ColoredButton>
                </a>
            }
            {
                !url &&
                <ColoredButton color={primaryColor} className={className} fluid={fluid === false ? fluid : true} onClick={onClick}
                    basic={basic}
                    // re-enable when custom props are actually used
                    // customColor={customColor}
                    // customFontColor={customFontColor}
                    >
                    {text}
                </ColoredButton>
            }
        </React.Fragment>
    )
}

export default ColoredButtonLink;